import axios from 'axios';
import TokenManager from './tokenManager';

// REACT_APP_API_URL points at the backend origin (see .env). The fallback
// matches the backend's default port (backend/.env PORT=3000).
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Include cookies for session
});

// Add request interceptor to attach JWT token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = TokenManager.getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Only set Content-Type for non-FormData requests
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json';
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor for error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorCode = error.response?.data?.error_code;
    const status = error.response?.status;

    // Handle token revocation (logout on one device)
    if (errorCode === 'TOKEN_REVOKED' || errorCode === 'TOKEN_BLACKLISTED') {
      console.warn('Token has been revoked. Redirecting to login...');
      // Clear all auth data
      TokenManager.clearTokens();
      
      // Dispatch custom event to notify AuthContext
      window.dispatchEvent(new CustomEvent('tokenRevoked', { 
        detail: { 
          reason: error.response?.data?.message || 'Token has been revoked',
          errorCode 
        } 
      }));
    }

    // Handle general 401 (expired token)
    if (status === 401 && !errorCode?.includes('TOKEN_REVOKED')) {
      console.warn('Token expired. Please login again.');
      window.dispatchEvent(new CustomEvent('tokenExpired'));
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
